import React from "react"

const _URL_IN_MESSAGE = /(https?:\/\/[^\s]+)/gi

/** http(s)://… в тексте — кликабельные ссылки; хвостовые знаки препинания отрезаем от href */
function linkifyPlainSegment(s: string, keyPrefix: string): React.ReactNode {
  const out: React.ReactNode[] = []
  let last = 0
  let m: RegExpExecArray | null
  let i = 0
  _URL_IN_MESSAGE.lastIndex = 0
  while ((m = _URL_IN_MESSAGE.exec(s)) !== null) {
    if (m.index > last) {
      out.push(s.slice(last, m.index))
    }
    const raw = m[1]
    const href = raw.replace(/[.,;:!?'")\]]+$/g, "")
    out.push(
      <a
        key={`${keyPrefix}-a-${i++}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="ai-chat__link"
      >
        {href}
      </a>
    )
    last = m.index + raw.length
  }
  if (last < s.length) {
    out.push(s.slice(last))
  }
  if (out.length === 0) {
    return s
  }
  if (out.length === 1) {
    return out[0]
  }
  return <>{out}</>
}

/** Фрагменты `**текста**` — жирным; внутри и снаружи — linkify ссылок */
export function renderChatMessageBody(text: string): React.ReactNode {
  const re = /\*\*([\s\S]*?)\*\*/g
  const parts: React.ReactNode[] = []
  let last = 0
  let m: RegExpExecArray | null
  let k = 0
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) {
      parts.push(
        <span key={`t-${k}`}>{linkifyPlainSegment(text.slice(last, m.index), `k${k}`)}</span>
      )
      k++
    }
    parts.push(
      <strong key={`b-${k}`}>{linkifyPlainSegment(m[1], `b${k}`)}</strong>
    )
    k++
    last = re.lastIndex
  }
  if (last < text.length) {
    parts.push(<span key={`t-${k}`}>{linkifyPlainSegment(text.slice(last), `k${k}`)}</span>)
  }
  return (
    <span className="ai-chat__message-body" style={{ whiteSpace: "pre-wrap" }}>
      {parts.length > 0 ? parts : linkifyPlainSegment(text, "root")}
    </span>
  )
}
